module.exports = __webpack_public_path__ + "static/media/dot-selected.7de7f0a2.svg";